import { SAA_SURVEY_META } from "utils/constant/STATUS";
import { AmountInput, AmountInputHelper, SurveyTitle } from "../component";
import { TYPO } from "styles/Typo";

interface Step0Props {
  saving_total: number | null;
  handleTotalSavings: (option: number) => void;
  expenseCategory?: string;
  type: "retire" | "consume";
}

export default function Step0({
  saving_total,
  handleTotalSavings,
  expenseCategory,
  type,
}: Step0Props) {
  const label =
    type === "consume"
      ? SAA_SURVEY_META["expense_category"][expenseCategory ?? ""]?.label
      : "노후 자금";
  const josa = require("josa-js");
  return (
    <div className="bg-background relative w-full   ">
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        <div className="w-full ">
          <div className="pt-4 px-6 space-y-1">
            <p className={`${TYPO.TYPO7_MD} text-blue50`}>{label}에 쓸 돈을</p>
            <p
              className={` w-full text-[26px] leading-[140%] font-[600]  text-gray90 whitespace-pre-line`}
            >
              지금까지 얼마나 모아뒀나요?
            </p>
          </div>

          <div className="px-6 py-4 space-y-[10px]">
            <AmountInput
              value={saving_total}
              setValue={handleTotalSavings}
              dataGtmId="saa-survey-total-amount-input"
            />
            <AmountInputHelper
              setValue={handleTotalSavings}
              units={[1000, 5000, 10000]}
              value={saving_total || 0}
              dataGtmId="saa-survey-total-amount-input-helper"
            />
          </div>
        </div>
        <div className="px-6 py-4"></div>
      </div>
    </div>
  );
}
